import { render, staticRenderFns } from "./create_vendor_mgmt.vue?vue&type=template&id=319425ab"
import script from "./create_vendor_mgmt.vue?vue&type=script&lang=js"
export * from "./create_vendor_mgmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports